import { render, staticRenderFns } from "./BlogPagination.vue?vue&type=template&id=6ed78aa6&scoped=true&"
import script from "./BlogPagination.vue?vue&type=script&lang=js&"
export * from "./BlogPagination.vue?vue&type=script&lang=js&"
import style0 from "./BlogPagination.vue?vue&type=style&index=0&id=6ed78aa6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed78aa6",
  null
  
)

export default component.exports